import SelectCheckmarks, { SelectCheckmarksProps } from "../../../components/Filter/Components/SelectCheckmarks"
import { styled, TableCell } from "@mui/material";
import TextCell from "./TextCell";
import { NormalTableRow, SmallContentTableRow, SmallTextTableRow } from "../Settings";

const SelectCheckmarkCell = styled(TableCell)(({theme}) => ({
    paddingLeft: "0px",
    [theme.breakpoints.down("md")]: {
        paddingLeft: "16px",
        paddingTop: "0"
    }
}))

interface ISelectCheckmarksRowProps extends SelectCheckmarksProps {
    textTitle: string,
    colspan?: number
    subtitle: string,
    info?: string,
    colSpan?: number,
    moreInfo?: React.ReactNode
    mobile: boolean
    active?: boolean
}

const SelectCheckmarksRow: React.FC<ISelectCheckmarksRowProps> = (props) => {

    return (
        props.mobile?
        <>
        <SmallTextTableRow>
            <TextCell colspan={3} title={props.textTitle} subtitle={props.subtitle} moreInfo={props.moreInfo}/>
        </SmallTextTableRow>
        <SmallContentTableRow>
            <SelectCheckmarkCell colSpan={props.colSpan? props.colSpan : 3} width="50%">
                <SelectCheckmarks
                    title={props.title}
                    value={props.value}
                    setValue={props.setValue}
                    type={props.type}
                    source={props.source}
                    active={props.active}
                />
            </SelectCheckmarkCell>
            
        </SmallContentTableRow>
        </>
        :
        <NormalTableRow>
            <TextCell title={props.textTitle} subtitle={props.subtitle} moreInfo={props.moreInfo}/>
            <SelectCheckmarkCell colSpan={props.colSpan? props.colSpan : 3} width="50%">
                <SelectCheckmarks
                    title={props.title}
                    value={props.value}
                    setValue={props.setValue}
                    type={props.type}
                    source={props.source}
                    active={props.active}
                />
            </SelectCheckmarkCell>
        </NormalTableRow>
    )
}

export default SelectCheckmarksRow